// The only libraries I could find to do this for us added an absurd
// amount of code (on the order of 350k) to the deployed app. Since we
// don't need to verify anything, we can get by with much simpler means.



// Allow “+/” (traditional) or “-_” (url-safe) conventions, as well as
// optional trailing “=” padding in each of the three “.” separated segments
const jwtPattern = /^([A-Za-z0-9+\/_-]+=*)\.([A-Za-z0-9+\/_-]+=*)\.([A-Za-z0-9+\/_-]+=*)$/;



// Takes a raw string JWT and returns the decoded payload. Does not
// verify the cryptographic signature.
//
// If anything goes wrong, this function will throw an error, so be
// sure to wrap it in a try/catch if you're not 100% sure it's well-formed.
export const jwtDecode = tok => {

  const matches = jwtPattern.exec(tok);

  // Expect one match for the whole string, plus one for each of the
  // three capture groups:
  if (matches?.length !== 4) {
    throw 'argument is not a JWT';
  }

  const [ _overall, _header, payload, _signature ] = matches;

  const jsonPayload = atob(payload);
  const objectifiedPayload = JSON.parse(jsonPayload);

  if (!objectifiedPayload || typeof objectifiedPayload !== 'object') {
    throw 'token did not contain an object';
  }

  return objectifiedPayload;
};
